import { useEffect, useState } from "react";
import { Toaster, toast } from "sonner";
import { Loader2 } from "lucide-react";
import { getSemaforoConfig, submitSemaforoResult, trackSemaforoEvent } from "@/lib/api";
import { Shell } from "./SemaforoUi";
import { Intro, Quiz } from "./SemaforoQuiz";
import { Result, LeadForm, Done } from "./SemaforoResult";
import { ExitPopup } from "./SemaforoExit";

const fonte = () => (typeof window !== "undefined" && window.location.search) || "semaforo";
const trackOnce = (evento) => {
  const key = `sem_${evento}`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch { /* storage bloccato */ }
  trackSemaforoEvent({ evento, fonte: fonte() });
};

export default function SemaforoPage() {
  const [domande, setDomande] = useState(null);
  const [step, setStep] = useState("intro");
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [res, setRes] = useState(null);
  const [lead, setLead] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Se domani si ferma uno stipendio, quanto reggete? — Il vostro conto in 5 domande";
    getSemaforoConfig().then((c) => setDomande(c.domande)).catch(() => toast.error("Non riesco a caricare il test: riprova."));
    trackOnce("view");
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [step, index]);

  const start = () => { trackOnce("start"); setStep("quiz"); setIndex(0); };

  const finish = async (all) => {
    setBusy(true);
    try {
      const r = await submitSemaforoResult({ ...all, fonte: fonte() });
      setRes(r);
      setStep("result");
    } catch { toast.error("Qualcosa non ha funzionato: riprova."); }
    finally { setBusy(false); }
  };

  const answer = (key, value) => {
    const all = { ...answers, [key]: value };
    setAnswers(all);
    if (index < domande.length - 1) setTimeout(() => setIndex(index + 1), 180);
    else finish(all);
  };

  const back = () => (index === 0 ? setStep("intro") : setIndex(index - 1));
  const restart = () => { setAnswers({}); setRes(null); setLead(null); setIndex(0); setStep("quiz"); };

  return (
    <Shell>
      <Toaster position="top-center" richColors />
      {!domande ? (
        <div className="flex items-center gap-2 text-sm" style={{ color: "#94A3B8" }} data-testid="semaforo-loading"><Loader2 size={16} className="animate-spin" /> Un attimo…</div>
      ) : busy ? (
        <div className="flex items-center gap-2 text-sm" style={{ color: "#94A3B8" }} data-testid="semaforo-computing"><Loader2 size={16} className="animate-spin" /> Calcolo il vostro ossigeno…</div>
      ) : step === "intro" ? (
        <Intro onStart={start} />
      ) : step === "quiz" ? (
        <Quiz domande={domande} index={index} answers={answers} onAnswer={answer} onBack={back} />
      ) : step === "result" ? (
        <Result res={res} onUnlock={() => setStep("form")} onRestart={restart} />
      ) : step === "form" ? (
        <LeadForm res={res} testId={res.test_id} fonte={fonte()} onDone={(l) => { setLead(l); setStep("done"); }} />
      ) : (
        <Done lead={lead} res={res} />
      )}
      {res && <ExitPopup active={step === "result"} mesiLabel={res.mesi_label} onUnlock={() => setStep("form")} />}
    </Shell>
  );
}
